import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';
import { wrapFetch } from '#/fetch-wrapper';

const readAmenityNotes = async id => {

    if (id === 0) {
        return {
            inEntrata: [],
            notInEntrata: [],
            unitTypeMappings: {},
            allUnits: [],
            property: {}
        };
    };

    const { data } = await api.get(`/properties/${id}/amenities`);

    return data;
};

export const useReadAmenityNotes = (id, queryOptions = {}) => useQuery(['amenity-notes', id], () => readAmenityNotes(id), queryOptions);

const realAllAmenityNotes = async () => {
    const { data } = await api.get('/entrata/amenity-report');

    return data;
};

export const useReadAllAmenityNotes = (queryOptions = {}) => useQuery('all-amenity-notes', realAllAmenityNotes, queryOptions);
export const useDeleteAmenityNotes = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => deleteAmenityNotes(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('amenity-notes');
        },
        ...queryOptions
    });
};

const deleteAmenityNotes = payload => wrapFetch(() => api.post('/amenity-notes/delete', payload));


const FetchUnitTypeMappings = async () => {
    const { data } = await api.get('/fetch-unit-type-mappings');

    return data;
};

export const useFetchUnitTypeMappings = (queryOptions = {}) => useQuery(['fetch-unit-type-mappings'], () => FetchUnitTypeMappings(), queryOptions);


const createOrUpdateOrder = async payload => {
    const { data } = await api.put('/amenity-notes', payload);

    return data;
};

export const useCreateOrUpdateOrder = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => createOrUpdateOrder(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('amenity-notes');
        },
        ...queryOptions
    });
};

const getAllUnitsInProperty = async property_id => {

    const { data } = await api.get(`/fetch-unit-type-data/${property_id}`);

    return data;
};

export const useGetAllUnitsInProperty = (property_id, queryOptions = {}) => useQuery(['fetch-unit-type-data', property_id], () => getAllUnitsInProperty(property_id), queryOptions);


const FetchUnitTypeMappingsByProperty = async property_id => {

    const { data } = await api.get(`/fetch-unit-type-mappings/${property_id}`);

    return data;
};

export const useFetchUnitTypeMappingsByProperty = (property_id, queryOptions = {}) => useQuery(['fetch-unit-type-mapping-by-property', property_id], () => FetchUnitTypeMappingsByProperty(property_id), queryOptions);


const createBundleOrder = async payload => {
    const { data } = await api.put('/amenity-notes/bundle', payload);

    return data;
};

export const useCreateBundleOrder = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => createBundleOrder(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('amenity-notes');
        },
        ...queryOptions
    });
};
